import { OliPaintVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { oilPaint } from '@cloudinary/url-gen/actions/effect'
import { SliderField } from './SliderField'

export const OilPaintVariant = (props: OliPaintVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={0}
        maxValue={100}
        step={1}
        initialValue={variant.qualifier ?? 30}
        label="Adjust oilpaint effect level"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(oilPaint(value))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'oil_paint', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
